export const optionsMaterialEnum = [
  { value: 'app', label: 'Aplicativo' },
  { value: 'envelope', label: 'Envelope' },
  { value: 'material', label: 'Aplicativo e Envelope' }
];

export const optionsPendenciasAbertasEnum = [
  { value: 'sim', label: 'Sim' },
  { value: 'nao', label: 'Não' }
];

export const optionsStatusEscolaEnum = [
  { value: 'NAO_ENVIOU_MATERIAL', label: 'Não enviou material' },
  { value: 'INVALIDA', label: 'Inválida' },
  { value: 'ENVIOU_MATERIAL', label: 'Em processamento' },
  { value: 'FINALIZADA', label: 'Finalizada' }
]

export const optionsMotivosDescarteEnum = [
  { value: 'DESCLASSIFICADO', label: 'Desclassificado' },
  { value: 'DUPLICADO', label: 'Duplicado' },
	{ value: 'OUTRO', label: 'Outro' }
]

export const optionsDiscrepanciaEnum = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10 , 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]
                                        .map(value => ({ label: value, value: value }));

export const optionsNotasEnum = ['sem nota','0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10' , '11', '12', '13', '14', '15', '16', '17', '18', '19', '20']
                                        .map(value => ({ label: value, value: value }));
